module.exports = __webpack_public_path__ + "img/img_origfac8x11.733e8dc1.png";